import LUMConfirmationDialog from './component'
export default LUMConfirmationDialog
